import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import VueSilentbox from 'vue-silentbox'
import VLazyImage from 'v-lazy-image'
import VueSweetalert2 from 'vue-sweetalert2'
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

InertiaProgress.init()

function loadZiggyAndStartApp() {
  fetch('/api/ziggy')
    .then(response => {
      if (!response.ok) {
        throw new Error('Networkerror')
      }
      return response.json()
    })
    .then(Ziggy => {
      InertiaProgress.init()

      createInertiaApp({
        resolve: name => require(`./Pages/${name}`),
        title: title => title ? `${title} - ${process.env.APP_NAME}` : process.env.APP_NAME,
        setup({ el, App, props, plugin }) {
          createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(VueSilentbox)
            .use(VueSweetalert2)
            .use(ZiggyVue, Ziggy)
            .mixin(require('./translation'))
            .component('v-lazy-image', VLazyImage)
            .component('font-awesome-icon', FontAwesomeIcon)
            .mount(el)
        },
      })
    })
    .catch(error => console.error('Error while loading ziggy-configuration:', error))
}

loadZiggyAndStartApp()
